import { render, staticRenderFns } from "./InformativaAcessoPorGrupoUsuarios.vue?vue&type=template&id=53aee38e&"
import script from "./InformativaAcessoPorGrupoUsuarios.vue?vue&type=script&lang=js&"
export * from "./InformativaAcessoPorGrupoUsuarios.vue?vue&type=script&lang=js&"
import style0 from "./InformativaAcessoPorGrupoUsuarios.vue?vue&type=style&index=0&id=53aee38e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports